export default "__VITE_ASSET__Dbz3GJiK__"